<template>
  <button
    class="rectangle-button"
    :class="{outline:outline,disabled:disabled}"
    @click="$_onclick()"
  >
    <div class="title-wrap">
      <i
        v-if="leadingIcon"
        :class="leadingIcon"
      />
      <p :class="{gray:placeHolder}">
        {{ _computedTextLabel }}
      </p>
    </div>
    <i
      v-if="trailingIcon"
      :class="trailingIcon"
    />
  </button>
</template>
<script>
export default {
  name: "RectangleButton",
  props: {
    textLabel: {
      type: String,
      default: "",
    },
    placeHolder: {
      type: String,
      default: "",
    },
    outline: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    trailingIcon: {
      type: String,
      default: "",
    },
  },
  computed: {
    _computedTextLabel() {
      let placeholder = this.placeHolder;
      let textLabel = this.textLabel;
      if (textLabel) {
        return this.$t(textLabel);
      } else {
        return placeholder;
      }
    },
  },
  methods: {
    $_onclick() {
      if (this.disabled) {
        return;
      }
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" >
@import "@/assets/scss/component/rectangle-button";
</style>